import { useEffect } from 'react'

export const useScript = (src: string, onLoad: () => void): void =>
  useEffect(() => {
    const scriptElement = document.createElement('script')
    scriptElement.src = src
    scriptElement.onload = onLoad
    document.body.appendChild(scriptElement)
  }, [src])
